import { useQuery } from '@tanstack/react-query';
import { partnerService } from '../services/partner.service';

export function usePartnerProfile(enabled = true) {
  return useQuery({
    queryKey: ['partner', 'profile'],
    queryFn: () => partnerService.getProfile(),
    staleTime: 1000 * 60 * 5,
    retry: false,
    enabled,
  });
}
